import * as types from './mutation_types';

export default {
  [types.USER_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.USER_RESET](state) {
    Object.assign(state, {
      error: '',
    });
  },

  [types.USER_SET_LOADING](state, loading) {
    Object.assign(state, { isLoading: loading });
  },

  [types.USER_LOGOUT](state) {
    Object.assign(state, { token: '', user: {}, userId: '', trainer: {}, adminToken: '', adminUser: {}, adminUserId: '' });
    // Správně maže ze sessionStorage
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('userId');
    // Bez tohohle přežil admin stash (Kelghorův token uložený přes impersonate)
    // odhlášení impersonované session - dalšímu uživateli, který se ve stejném
    // prohlížeči přihlásil, se pak "isImpersonating" tvářilo jako true a viděl
    // "Přepnout uživatele" apod. (nahlaseno uzivatelem 2026-07-24).
    sessionStorage.removeItem('adminToken');
    sessionStorage.removeItem('adminUser');
    sessionStorage.removeItem('adminUserId');
  },

  [types.USER_SET_USER](state, item) {
    Object.assign(state, { item: item });
    // Správně ukládá do sessionStorage
    sessionStorage.setItem('user', JSON.stringify(item));
  },

  [types.USER_SET_TOKEN](state, token) {
    Object.assign(state, { token: token });
    // Správně ukládá do sessionStorage
    sessionStorage.setItem('token', token);
  },

  [types.USER_SET_USERID](state, userId) {
    Object.assign(state, { userId: userId });
    // Správně ukládá do sessionStorage
    sessionStorage.setItem('userId', userId);
  },

  [types.USER_SET_USERS](state, items) {
    Object.assign(state, { items: items });
  },

  [types.USER_STASH_ADMIN](state, { token, user, userId }) {
    Object.assign(state, { adminToken: token, adminUser: user, adminUserId: userId });
    sessionStorage.setItem('adminToken', token);
    sessionStorage.setItem('adminUser', JSON.stringify(user));
    sessionStorage.setItem('adminUserId', userId);
  },

  [types.USER_CLEAR_ADMIN_STASH](state) {
    Object.assign(state, { adminToken: '', adminUser: {}, adminUserId: '' });
    sessionStorage.removeItem('adminToken');
    sessionStorage.removeItem('adminUser');
    sessionStorage.removeItem('adminUserId');
  },
};